import TitleBanner from "../title-banner";
import Quote from "../quote";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import ResponsiveImage from "../modules/responsive-image";
import TeasePost from "../tease-post";

const swiperSettings = {
  slidesPerView: 1,
  spaceBetween: 0,
  grabCursor: true,
};

export default function TemplateProjects({ page }) {
  return (
    <>
      {page.extra_fields.title && page.extra_fields.text && (
        <TitleBanner
          title={page.extra_fields.title}
          text={page.extra_fields.text}
          cssClasses="pb-50"
        />
      )}
      <div className="rounded-edge-shape rounded-edge-shape--up--green-lightest" />
      {page.extra_fields.slider && page.extra_fields.slider.length && (
        <div className="template-projects__slider-block pt-50 pb-75 text-center">
          <div className="container">
            <div className="frame frame--justify-md-center">
              <div className="bit-xxs-12 bit-md-10 bit-lg-9">
                <div className="ml-n15 mr-n15">
                  <Swiper
                    modules={[Pagination]}
                    spaceBetween={swiperSettings.spaceBetween}
                    slidesPerView={swiperSettings.slidesPerView}
                    pagination={{ clickable: true }}
                    grabCursor={swiperSettings.grabCursor}
                  >
                    {page.extra_fields.slider.map((slide) => {
                      return (
                        <SwiperSlide key={slide.title}>
                          <div className="pl-15 pr-15">
                            {slide.title && (
                              <h2 className="pb-20">{slide.title}</h2>
                            )}
                            {slide.text && (
                              <div
                                className="pb-30"
                                dangerouslySetInnerHTML={{ __html: slide.text }}
                              />
                            )}
                            {slide.quote && (
                              <div className="pl-md-50 pr-md-50">
                                <Quote text={slide.quote} />
                              </div>
                            )}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {page.extra_fields.quote_text && page.extra_fields.quote_image && (
        <div className="template-projects__quote-block">
          <div className="container">
            <div className="frame frame--justify-md-center">
              <div className="bit-xxs-12 bit-lg-10 pt-0 pb-0">
                <div className="template-projects__quote-block__quote">
                  <div
                    className="template-projects__quote-block__text"
                    dangerouslySetInnerHTML={{
                      __html: page.extra_fields.quote_text,
                    }}
                  />
                  <figure className="template-projects__quote-block__image">
                    <ResponsiveImage
                      image={page.extra_fields.quote_image}
                      classes="template-projects__quote-block__image__img"
                      layout="fill"
                    />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="template-projects__projects pt-75 pb-75">
        <div className="container">
          <div className="frame frame--justify-sm-center">
            <div className="bit-xxs-12 bit-sm-11 bit-md-10 bit-lg-8 text-center pt-md-50 pb-md-30">
              {page.extra_fields.title_above_projects && (
                <h2 className="pb-20">
                  {page.extra_fields.title_above_projects}
                </h2>
              )}
              {page.extra_fields.text_above_projects && (
                <div
                  className="text--gray text--weight-normal"
                  dangerouslySetInnerHTML={{
                    __html: page.extra_fields.text_above_projects,
                  }}
                />
              )}
            </div>
          </div>
          <div className="frame frame--justify-md-center m-0">
            <div className="bit-xxs-12 bit-lg-10 p-0">
              <div className="frame">
                {page.extra_fields.projects &&
                  page.extra_fields.projects.length &&
                  page.extra_fields.projects.map((project, i) => {
                    let bitClasses =
                      i === 0 ? "bit-xxs-12" : "bit-xxs-12 bit-sm-6";
                    return (
                      <div
                        className={`${bitClasses} pb-30 pb-md-50`}
                        key={project.title}
                      >
                        <TeasePost
                          title={project.title}
                          excerpt={project.excerpt}
                          date={project.date}
                          image={project.image}
                          url={project.url}
                          link_text={project.link_text}
                          is_large={i === 0}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
